import { apiClient } from '../api-client'

export interface RoleRecord {
  id: string
  name: string
  display_name?: string
  is_active?: boolean
}

export const rolesApi = {
  getRoles: async (params?: {
    skip?: number
    limit?: number
    include_permissions?: boolean
    active_only?: boolean
  }): Promise<RoleRecord[]> => {
    const response = await apiClient.get<any>('/roles/', {
      params: {
        skip: params?.skip ?? 0,
        limit: params?.limit ?? 500,
        include_permissions: params?.include_permissions ?? false,
        active_only: params?.active_only ?? true,
      },
    })

    if (Array.isArray(response)) return response
    if (Array.isArray(response?.data)) return response.data
    return []
  },
}

